import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Container, Title, Calendar, TimeSlotsWrapper, CalendarWrapper } from './dateSelection.styles';
import TimeSlots from './timeSlots/timeSlots.container';
import messages from './dateSelection.messages';
import { DeferMount } from '../../../shared/components/deferMount';
import { HiddenOnPlatform } from '../../../shared/components/hiddenOnPlatform';

export class DateSelection extends PureComponent {
  static propTypes = {
    bookingDate: PropTypes.number,
  };

  render() {
    const DeferComponent = this.props.bookingDate ? Fragment : DeferMount;

    return (
      <Container>
        <CalendarWrapper>
          <HiddenOnPlatform desktop desktopWide desktopFull>
            <Title>
              <FormattedMessage {...messages.dates} />
            </Title>
          </HiddenOnPlatform>
          <DeferComponent>
            <Calendar />
          </DeferComponent>
        </CalendarWrapper>
        <TimeSlotsWrapper>
          <Title>
            <FormattedMessage {...messages.times} />
          </Title>
          <TimeSlots />
        </TimeSlotsWrapper>
      </Container>
    );
  }
}
